import req from './http.js'

// 更新供應商資料
export const apiGetAccountList = params => req('post', '/reservation/merchant/getAccountList', params)

// 寄簡訊給店家重新設定密碼 但好像沒在用
export const apiRequestReset = id => req('get', '/reservation/merchant/requestReset/' + id)

// 建立店家下面的子帳號
export const apiCreateAccount = params => req('post', '/reservation/merchant/createAccount', params)

// 更新店家帳號資料
export const apiUpdateAccount = params => req('post', '/reservation/merchant/updateAccount', params)

// 刪除店家帳號
export const apiDeleteMerchantAccount = params => req('post', '/reservation/merchant/deleteMerchantAccount', params)

// 取得核銷紀錄
export const apiGetExecutionEventList = params => req('post', '/reservation/merchant/getExecutionEventList', params)

// 取得核銷歷史事件
export const apiGetExecutionEvents = params => req('post', '/reservation/merchant/getExecutionEvents', params)

// 用AA票取得票的狀態
export const apiGetTicketStatus = params => req('post', '/reservation/merchant/getTicketStatus', params)

// 取得請款單列表
export const apiGetPaymentRequestFormList = params => req('post', '/reservation/merchant/getPaymentRequestFormList', params)

// 取得請款單明細
export const apiGetPaymentRequestFormDetail = params => req('post', '/reservation/merchant/getPaymentRequestFormDetail', params)

// 建立請款單
export const apiCreatePaymentRequestForm = params => req('post', '/reservation/merchant/createPaymentRequestForm', params)

// 更新請款單資料
export const apiUpdatePaymentRequestForm = params => req('post', '/reservation/merchant/updatePaymentRequestForm', params)

// 刪除請款單
export const apiCancelPaymentRequestForm = params => req('post', '/reservation/merchant/cancelPaymentRequestForm', params)

// 下載請款單明細EXCEL檔案
export const apiGetPFDetailXls = params => req('post', '/reservation/merchant/getPFDetailXls', params)

// 取得未核銷的票
export const apiGetUsedWaitProcessTickets = params => req('post','/reservation/merchant/getUsedWaitProcessTickets', params)

// 停用商家帳號
export const apiChangeAccountStopStatus = params => req('post', '/reservation/merchant/changeAccountStopStatus', params)

// 管理員取得銷售報表
export const apiGetAdminProductPerformanceView = params => req('post','/reservation/merchant/getAdminProductPerformanceView', params)

// 供應商取得銷售報表
export const apiGetMerchantProductPerformanceView = params => req('post','/reservation/merchant/getMerchantProductPerformanceView', params)

// 店家取得銷售報表
export const apiGetStoreProductPerformanceView = params => req('post','/reservation/merchant/getStoreProductPerformanceView', params)

// 下載選取的請款單
export const apiGetPFDetailXls3 = params => req('post','/reservation/merchant/getPFDetailXls3', params)

// 取得退票詳細資料
export const apiGetCancelDetail = params =>req('post', '/reservation/merchant/getCancelTicketDetail', params)

// 報表資料
export const apiGetProductPerformanceView = params => req('post', '/reservation/merchant/getProductPerformanceView', params)





